module.exports = __webpack_public_path__ + "assets/img/center-layer-1-cb5eaa9e.png";